const TRACKING_PREFIX = 'schedule-onboarding-flow';

export const ONBOARDING_FLOW_TRACKING_IDS = {
  wizardStarted: `${TRACKING_PREFIX}:wizard-started`,
  wizardVerticalStepCompleted: `${TRACKING_PREFIX}:wizard-vertical-step-completed`,
  wizardLocationStepCompleted: `${TRACKING_PREFIX}:wizard-location-step-completed`,
  wizardAppointmentTypeStepCompleted: `${TRACKING_PREFIX}:wizard-appointment-type-step-completed`,
  wizardProviderStepCompleted: `${TRACKING_PREFIX}:wizard-provider-step-completed`,
  wizardContactStepCompleted: `${TRACKING_PREFIX}:wizard-contact-step-completed`,
  wizardCompleted: `${TRACKING_PREFIX}:wizard-completed`,
  firstAppointmentBooked: `${TRACKING_PREFIX}:first-appointment-booked`,
  autoMessagedActivated: `${TRACKING_PREFIX}:auto-messaged-activated`,
  upgradeToAutoMessages: `${TRACKING_PREFIX}:upgrade-to-auto-messages`,
  skippedAutoMessages: `${TRACKING_PREFIX}:skipped-auto-messages`,
  skippedToNextLogin: `${TRACKING_PREFIX}:skipped-to-next-login`,
  wizardSkipped: `${TRACKING_PREFIX}:wizard-skipped`,
  onboardingFlowNotRequired: `${TRACKING_PREFIX}:onboarding-flow-not-required`,
} as const;
